const KEY = 'stocko_caissier_session'

export function saveCaissierSession(data) {
  localStorage.setItem(KEY, JSON.stringify(data))
}

export function getCaissierSession() {
  try { return JSON.parse(localStorage.getItem(KEY)) }
  catch { return null }
}

export function clearCaissierSession() {
  localStorage.removeItem(KEY)
}

export function isCaissierMode() {
  return !!getCaissierSession()
}
